var MDB = window.MDB || {};


$.extend(MDB, {
    initKendoDatePickers: function (selector) {
        selector = $(selector || 'body');

        selector.find('[data-type="datepicker"]').kendoDatePicker({
	        dateInput: true,
	        format: 'dd-MM-yyyy',
	        parseFormats: ["dd MM yyyy"]
	    });
    }
});


$(document).ready(function() {
    //Kendo is not loaded on all pages
    if($.fn.kendoDatePicker){
        MDB.initKendoDatePickers();
    }
});